module.exports = __webpack_public_path__ + "static/media/value-prop-icon-1.4fab8da7.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/TCH-WEB/value-prop-icon-1.svg
// module id = 1296
// module chunks = 0